import React, {useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import ConfirmData from './ConfirmHeader';
import {axiosHandler} from '../../../network';
import {LocStore} from '../../../utils';
import {forgetDirectReturn, pruneDirectReturns, savedDirectReturn} from '../../../utils/pgDirect';
import pinStore from '../../../store/pinStore';
import timeStore from '../../../store/timeStore';
import shopStore from '../../../store/shopStore';

// 단건 직접결제 복귀 화면. 서버가 이미 확정했으므로 imp_uid 확정 호출은 하지 않는다.
// URL 의 result 는 누구나 만들 수 있다 — 어떤 값이든 '확인 중'으로 시작하고, direct-status 가 답한 상태로만 화면을 정한다(paid 일 때만 기존 성공 화면).
const VIEWS = {
    pending: {title: '결제 확인 중', caption: '결제 확인 중입니다. 잠시 후 예약 내역을 확인해 주세요.'},
    cancel: {title: '결제 취소됨', caption: '결제를 취소했습니다.'},
    fail: {title: '결제 실패', caption: '결제가 완료되지 않았습니다. 다시 예약해 주세요.'},
};
const STATUS_VIEW = {pending: 'pending', failed: 'fail', cancelled: 'cancel'};
const ERROR_NOTICE = {
    401: '로그인 정보가 만료되어 결과를 확인하지 못했습니다. 예약 내역에서 확인해 주세요.',
    403: '다른 회원의 예약이라 결과를 확인할 수 없습니다.',
    404: '직접결제 예약을 찾지 못했습니다. 지점으로 문의해 주세요.',
};
const UNKNOWN_NOTICE = '결제 결과를 확인하지 못했습니다. 재결제하지 말고 잠시 후 다시 확인해 주세요.';

export default function DirectReturn({moid, setSms, sms}) {
    const [view, setView] = useState('pending');
    const [paid, setPaid] = useState(false);
    const [checking, setChecking] = useState(false);
    const [notice, setNotice] = useState('');
    const started = useRef(false);
    const stNo = savedDirectReturn(moid)?.stNo ?? LocStore('roomNo');
    const member = LocStore('userToken');

    async function check() {
        if (stNo == null || !member) { setNotice(ERROR_NOTICE[401]); return; }
        setChecking(true);
        setNotice('');
        try {
            const res = await axiosHandler({method: 'POST', url: `/rooms/${stNo}/reservation/direct-status`, data: {moid, member}, token: `Bearer ${LocStore(`shopToken_${shopStore.spno}`)}`});
            const code = Number(res?.data?.resultCode);
            if (code !== 200) { setNotice(ERROR_NOTICE[code] ?? UNKNOWN_NOTICE); return; }
            const data = res.data.data ?? {};
            if (data.status === 'paid') {
                pinStore.setPinCode(data.sdCode, data.sdPin);
                if (data.reservedTime) {
                    timeStore.setReservedTime(data.reservedTime);
                    LocStore('reservedTime', {reservedTime: data.reservedTime});
                }
                setPaid(true);
            } else setView(STATUS_VIEW[data.status] ?? 'pending');
            // paid 기록은 남긴다 — PC 는 roomNo 가 없어, 확정 뒤 새로고침하면 이 기록의 방 번호가 유일한 출처다(24시간 정리).
            if (['failed', 'cancelled'].includes(data.status)) forgetDirectReturn(moid);
        } catch (err) {
            setNotice(ERROR_NOTICE[Number(err?.response?.status ?? err?.response?.data?.resultCode)] ?? UNKNOWN_NOTICE);
        } finally {
            setChecking(false);
        }
    }

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        pruneDirectReturns();
        check();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (paid) return <ConfirmData setSms={setSms} sms={sms}/>;
    const current = VIEWS[view] ?? VIEWS.fail;
    return <div className="bundle-done">
        <header className="bundle-done-card bundle-done-header" role="status">
            <h2 style={view === 'fail' ? {color: 'var(--danger-text)'} : undefined}>{current.title}</h2>
            <p className="bundle-done-caption">{current.caption}</p>
            {notice && <p className="bundle-done-caption">{notice}</p>}
        </header>
        {view === 'pending' && <div className="reserved_btn bundle-done-actions">
            <button type="button" disabled={checking} onClick={check}>다시 확인</button>
            <Link className="bundle-done-primary" to="/my">내 예약 보기</Link>
        </div>}
    </div>;
}
